
import React, { useRef } from 'react';
import { useDataWave } from './three/useDataWave';

/**
 * Abstract data wave visualization component
 * Creates a flowing, undulating wave of points that represents data analysis
 */
const DataVisualization = () => {
  const canvasRef = useRef<HTMLDivElement>(null);

  // Use our custom hook to handle all Three.js setup and animation
  useDataWave(canvasRef, {
    particleCount: 8000,
    waveWidth: 30,
    waveDepth: 20,
    particleSize: 0.05,
    maxEmitters: 3,
    emitterChance: 0.005
  });
  
  return (
    <div ref={canvasRef} className="absolute inset-0 w-full h-full" />
  );
};

export default DataVisualization;
